// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';
import * as constants from './constants';
import { OrderExplainerState } from './types';

export const initialState: OrderExplainerState = {
	data: {},
	loading: {},
	error: {},
	drawerOpen: false,
	drawerOrderDetailId: null,
	drawerRowData: null,
};

const slice = createSlice({
	initialState,
	name: `model/${constants.MODEL_NAME}`,
	reducers: {
		openOrderExplainerDrawer(state, { payload }) {
			state.drawerOpen = true;
			state.drawerOrderDetailId = payload.orderDetailId;
			state.drawerRowData = payload.rowData ?? null;
		},
		closeOrderExplainerDrawer(state) {
			state.drawerOpen = false;
			state.drawerOrderDetailId = null;
			state.drawerRowData = null;
		},
		setOrderExplanation(state, { payload: { orderDetailId, data } }) {
			return {
				...state,
				data: {
					...state.data,
					[orderDetailId]: data,
				},
				error: {
					...state.error,
					[orderDetailId]: null,
				},
			};
		},
		setOrderExplanationLoading(state, { payload: { orderDetailId, loading } }) {
			return {
				...state,
				loading: {
					...state.loading,
					[orderDetailId]: loading,
				},
			};
		},
		setOrderExplanationError(state, { payload: { orderDetailId, error } }) {
			return {
				...state,
				loading: {
					...state.loading,
					[orderDetailId]: false,
				},
				error: {
					...state.error,
					[orderDetailId]: error,
				},
			};
		},
	},
});

export default slice;

export const {
	openOrderExplainerDrawer,
	closeOrderExplainerDrawer,
	setOrderExplanation,
	setOrderExplanationLoading,
	setOrderExplanationError,
} = slice.actions;

